import * as React from 'react';
import { IHeiStoreContactViewProps } from './hei-store-contact';
import classnames from 'classnames';

export default (props: IHeiStoreContactViewProps) => {
    const {
        phoneNumber,
        emailAddress,
        resources: { emailLabel, phoneLabel },
        config: { className }
    } = props;

    return (
        <div className={classnames('hei-store-contact', className)}>
            {phoneNumber && (
                <p className='hei-store-contact__phone'>
                    <label>{phoneLabel}</label>
                    {` `}
                    <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                </p>
            )}
            {emailAddress && (
                <p className='hei-store-contact__email'>
                    <label>{emailLabel}</label>
                    {` `}
                    <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </p>
            )}
        </div>
    );
};
